import { FC } from 'react'

import { useTheme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'

import type { WeGotTheBeat } from '../interfaces'
import BeatMaterialIcon from './BeatMaterialIcon'
import { getColorType } from '../utils/colorType'

export const AreaChartIcon: FC<WeGotTheBeat> = ({ beat }) => {
  const theme = useTheme()
  const colorType = getColorType(beat.data_series)
  const bgColor = theme.palette[colorType].main

  return (
    <BeatMaterialIcon
      bgColor={alpha(bgColor, 0.15)}
      fill={false}
      iconColor={colorType}
      name="area_chart"
    />
  )
}
